import { styled } from '@mui/system'
import { Box, Tooltip } from '@mui/material'
import { grey } from '../../colors'
import theme from '../../theme'

interface BoxProps {
  visibility?: 'hidden' | 'visible'
  opacity?: number
  flexDirection?: 'row' | 'column'
  gap?: number | string
  overflow?: 'hidden' | 'auto' | 'scroll' | 'visible'
  textAlign?: 'left' | 'center' | 'right' | 'justify' | 'start' | 'end'
  fontSize?: number | string
  pb?: number | string
  pl?: number | string
  pr?: number | string
}

interface TooltipProps {
  title: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  arrow?: boolean
}

const StyledGenericFlexContainer = styled(Box)<BoxProps>(({
  flexDirection = 'column',
  gap = 0
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection,
  gap
}))

const StyledModalContainer = styled(Box)<BoxProps>(({ theme }) => ({
  width: theme.spacing(180),
  height: theme.spacing(180),
  display: 'flex',
  justifyContent: 'top',
  flexDirection: 'column',
  backgroundColor: grey[0],
  borderRadius: theme.spacing(2)
}))

const StyledPageContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
  flexGrow: 1,
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}))

const StyledNavigationContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(5)
}))

const StyledIconContainer = styled(Box)<BoxProps>(({ visibility, opacity }) => ({
  cursor: 'pointer',
  '&:hover': { opacity: 0.7 },
  opacity,
  visibility
}))

const StyledForwardArrowTooltip = styled(Tooltip)<TooltipProps>(({
  title,
  placement,
  arrow
}) => ({
  title,
  arrow,
  placement
}))

const StyledHeader = styled(Box)<BoxProps>(({
  textAlign = 'center',
  fontSize = theme.spacing(4),
  pb = theme.spacing(6),
  pl = theme.spacing(6),
  pr = theme.spacing(6)
}) => ({
  fontFamily: theme.typography.fontFamily ?? 'inherit',
  fontSize,
  fontWeight: 'bold',
  textAlign,
  paddingTop: theme.spacing(6),
  paddingBottom: pb,
  paddingLeft: pl,
  paddingRight: pr
}))

const StyledText = styled(Box)<BoxProps>(({
  textAlign = 'center',
  fontSize = theme.spacing(4),
  pb = theme.spacing(4),
  pl = theme.spacing(6),
  pr = theme.spacing(6)
}) => ({
  fontFamily: theme.typography.fontFamily ?? 'inherit',
  fontSize,
  textAlign,
  paddingLeft: pl,
  paddingRight: pr,
  paddingTop: theme.spacing(4),
  paddingBottom: pb
}))

enum TaskResultStatus {
  ERROR = 'ERROR',
  SUCCESSFUL = 'SUCCESSFUL',
  PENDING = 'PENDING'
}

const StyledDistributionPlansTableContainer = styled(Box)<BoxProps>(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  width: '100%',
  borderTop: '1px solid',
  borderBottom: '1px solid',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}))

export {
  StyledGenericFlexContainer,
  StyledModalContainer,
  StyledPageContainer,
  StyledNavigationContainer,
  StyledIconContainer,
  StyledDistributionPlansTableContainer,
  StyledForwardArrowTooltip,
  StyledHeader,
  StyledText,
  TaskResultStatus
}
